export default {
  addEnum: '新增枚举',
  edit: '修改',
  delete: '删除',

  enumsKey: '枚举键',
  name: '名称',
  nameEn: '英文名称',
  sort: '排序',
  createTime: '创建时间',
  operation: '操作',

  addEnumTitle: '新增枚举',
  editEnumTitle: '修改枚举',

  enumsKeyField: '枚举键',
  enumsKeyPlaceholder: '请输入枚举键，如 robot_type',
  nameField: '名称',
  namePlaceholder: '请输入名称',
  nameEnField: '英文名称',
  nameEnPlaceholder: '请输入英文名称',
  sortField: '排序',
  sortPlaceholder: '请输入排序',

  enumsKeyRequired: '请输入枚举键',
  nameRequired: '请输入名称',
  nameEnRequired: '请输入英文名称',
  sortRequired: '请输入排序',

  cancel: '取消',
  confirm: '确定',

  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '是否删除"{name}"?',
  deleteConfirm: '删除',
}
